import { ProductType, ProductName } from '@sso/shared/constants';
import { Text } from '@sso/shared/core';

import { Container, TitleContainer, Badge } from './Header.styles';

function Header({ product }: { product: ProductType }) {
    return (
        <Container $product={product}>
            <TitleContainer>
                <Text color="neutral.white" size="textXs" weight="semiBold">
                    OpenVPN
                </Text>
                <Badge color="neutral.white" size="textXs">
                    {product === ProductType.As ? 'Self-hosted' : 'Cloud-delivered'}
                </Badge>
            </TitleContainer>
            <Text color="neutral.white" size="displayLg" weight="semiBold" wide as="h3">
                {ProductName[product]}
            </Text>
        </Container>
    );
}

export default Header;
